module.exports = __webpack_public_path__ + "static/img/app_bg6.0f1d0ff.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/app_bg6.jpg
// module id = N/c9
// module chunks = 0